import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Tag } from "antd";

import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

export const staffListColumns = (
  deleteMutation,
  token,
  setLoading,
  history
) => {
  return [
    {
      title: "ID",
      dataIndex: "id",
      width: 80,
    },
    {
      title: i18n.t("merchantStaff.name"),
      dataIndex: "employee_name",
    },
    {
      title: i18n.t("merchantStaff.mobile"),
      render: (item) => item?.user?.mobile || "-",
    },
    {
      title: i18n.t("merchantStaff.status"),
      render: (item) =>
        Number(item.status) === 1 ? (
          <Tag color="green">{i18n.t("merchantStaff.statusActive")}</Tag>
        ) : (
          <Tag>{i18n.t("merchantStaff.statusInactive")}</Tag>
        ),
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
    },
    {
      title: i18n.t("users.actions"),
      render: (item) => {
        return (
          <>
            <Button
              onClick={() => {
                history.push({
                  pathname: "/main/setting/staff/edit",
                  state: {
                    id: item.id,
                  },
                });
              }}
              size="small"
              icon={<EditOutlined />}
              style={{ marginRight: 8 }}
            >
              {i18n.t("product.productItem.actionEdit")}
            </Button>
            <Popconfirm
              title={i18n.t("sales.deleteWarning")}
              onConfirm={() => {
                setLoading(true);
                deleteMutation.mutate({
                  resource: "merchant-employee",
                  params: {
                    id: item.id,
                    token,
                  },
                });
              }}
              okText={i18n.t("base.modal.okText")}
              cancelText={i18n.t("base.modal.cancelText")}
            >
              <Button size="small" icon={<DeleteOutlined />} danger>
                {i18n.t("common.delete")}
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];
};
